export default __webpack_public_path__ + "images/cee7ab82f1bee1c1924af2ac0e57e9f2.svg";